export type CollapsedThreadPreviewItem =
  | { type: 'message'; role: 'user' | 'assistant'; content: string }
  | { type: 'event'; label: string; detail?: string }
  | { type: 'document'; title: string };

export type CollapsedThreadPreview = {
  kind: 'assistant' | 'event' | 'document';
  text: string;
};

const toPlainPreview = (value: string): string =>
  value
    .replace(/!\[[^\]]*\]\([^)]*\)/g, '')
    .replace(/\[([^\]]+)\]\([^)]*\)/g, '$1')
    .replace(/[`*_>#~|]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
// No length cap: display truncation is a CSS concern (the collapsed bar
// ellipsizes physically); the preview string must carry the full text.

export const getCollapsedThreadPreview = (
  items: CollapsedThreadPreviewItem[],
): CollapsedThreadPreview | null => {
  for (let index = items.length - 1; index >= 0; index -= 1) {
    const item = items[index];
    if (item.type === 'message') {
      if (item.role !== 'assistant') {
        continue;
      }
      const text = toPlainPreview(item.content);
      if (text) {
        return { kind: 'assistant', text };
      }
      continue;
    }

    if (item.type === 'event') {
      const text = toPlainPreview(item.detail || item.label);
      if (text) {
        return { kind: 'event', text };
      }
      continue;
    }

    if (item.type === 'document') {
      const text = toPlainPreview(item.title);
      if (text) {
        return { kind: 'document', text };
      }
    }
  }

  return null;
};

export const getLatestRunningEvent = (
  items: Array<CollapsedThreadPreviewItem & { tone?: string }>,
): { label: string; detail?: string } | null => {
  for (let index = items.length - 1; index >= 0; index -= 1) {
    const item = items[index];
    if (item.type === 'event' && item.tone === 'running') {
      return { label: item.label, detail: item.detail };
    }
  }
  return null;
};
